import { render, staticRenderFns } from "./exam-candidates.vue?vue&type=template&id=ff1efa0c&scoped=true"
import script from "./exam-candidates.vue?vue&type=script&lang=ts"
export * from "./exam-candidates.vue?vue&type=script&lang=ts"
import style0 from "./exam-candidates.vue?vue&type=style&index=0&id=ff1efa0c&prod&lang=scss"
import style1 from "./exam-candidates.vue?vue&type=style&index=1&id=ff1efa0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1efa0c",
  null
  
)

export default component.exports